import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "error"
}
const _hoisted_2 = { class: "form-actions" }
const _hoisted_3 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tabs = _resolveComponent("Tabs")
  const _component_FormGroup = _resolveComponent("FormGroup")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock(_component_Modal, {
    isOpen: $props.show,
    title: $data.isLogin === 'login' ? 'Login' : 'Register',
    onClose: $options.close
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Tabs, {
        modelValue: $data.isLogin,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.isLogin) = $event)),
        tabs: [
        { label: 'Login', value: 'login' },
        { label: 'Register', value: 'register' }
      ]
      }, null, 8 /* PROPS */, ["modelValue"]),
      _createElementVNode("form", {
        onSubmit: _cache[5] || (_cache[5] = _withModifiers((...args) => ($options.handleSubmit && $options.handleSubmit(...args)), ["prevent"])),
        class: "auth-form"
      }, [
        ($data.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString($data.error), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_FormGroup, {
          label: "Email",
          for: "email",
          description: "Enter your email address."
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("input", {
              type: "email",
              id: "email",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.form.email) = $event)),
              required: ""
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $data.form.email]
            ])
          ]),
          _: 1 /* STABLE */
        }),
        ($data.isLogin === 'register')
          ? (_openBlock(), _createBlock(_component_FormGroup, {
              key: 1,
              label: "Name",
              for: "name",
              description: "Enter your full name."
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "name",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.form.name) = $event)),
                  required: ""
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $data.form.name]
                ])
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_FormGroup, {
          label: "Password",
          for: "password",
          description: "Must be at least 6 characters."
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("input", {
              type: "password",
              id: "password",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.form.password) = $event)),
              required: ""
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $data.form.password]
            ])
          ]),
          _: 1 /* STABLE */
        }),
        ($data.isLogin === 'register')
          ? (_openBlock(), _createBlock(_component_FormGroup, {
              key: 2,
              label: "Confirm Password",
              for: "confirmPassword",
              description: "Repeat your password."
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  id: "confirmPassword",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.form.confirmPassword) = $event)),
                  required: ""
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $data.form.confirmPassword]
                ])
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            type: "submit",
            class: "btn-primary",
            disabled: $data.loading
          }, _toDisplayString($data.loading ? 'Processing...' : $data.isLogin === 'login' ? 'Login' : 'Register'), 9 /* TEXT, PROPS */, _hoisted_3)
        ])
      ], 32 /* NEED_HYDRATION */),
      _createCommentVNode("div class=\"divider\">\n      <span>or</span>\n    </div>\n\n    <div class=\"google-auth\">\n      <button @click=\"handleGoogleAuth\" class=\"btn-google\" :disabled=\"loading\">\n        <svg viewBox=\"0 0 24 24\" class=\"google-icon\">\n          <path fill=\"#4285F4\" d=\"M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z\"/>\n          <path fill=\"#34A853\" d=\"M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z\"/>\n          <path fill=\"#FBBC05\" d=\"M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z\"/>\n          <path fill=\"#EA4335\" d=\"M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z\"/>\n        </svg>\n        Continue with Google\n      </button>\n    </div")
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["isOpen", "title", "onClose"]))
}